import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { authAPI } from '../utils/api';
import '../styles/Login.css';

const ResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token) return toast.error(t('auth.invalidResetLink'));
    if (password.length < 8) return toast.error(t('common.passwordMinLength'));
    if (password !== confirmation) return toast.error(t('profile.passwordMismatch'));

    try {
      setLoading(true);
      await authAPI.resetPassword(token, password);
      toast.success(t('auth.passwordResetSuccess'));
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.message || t('auth.resetPasswordError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1>{t('auth.createNewPassword')}</h1>
          {!token ? (
            <div className="auth-result"><p>{t('auth.invalidResetLink')}</p><Link to="/forgot-password">{t('auth.requestNewLink')}</Link></div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="new-password">{t('profile.newPassword')}</label>
                <input id="new-password" type="password" minLength="8" value={password} onChange={(event) => setPassword(event.target.value)} required autoComplete="new-password" />
              </div>
              <div className="form-group">
                <label htmlFor="confirm-password">{t('profile.confirmPassword')}</label>
                <input id="confirm-password" type="password" minLength="8" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required autoComplete="new-password" />
              </div>
              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? t('common.loading') : t('auth.saveNewPassword')}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
